import { Component, OnInit } from '@angular/core';
import { NotificationDto, NotificationsService } from '../../../notifications/notifications.service';

@Component({
  selector: 'app-notifications-slide',
  templateUrl: './notifications-slide.component.html',
  styleUrls: ['./notifications-slide.component.scss'],
  providers: [NotificationsService],
})
export class NotificationsSlideComponent implements OnInit {
  loading = false;
  notifications: NotificationDto[] = [];
  detailVisible = false;
  selectedNotification: NotificationDto | null = null;

  constructor(private notificationsService: NotificationsService) {}

  ngOnInit(): void {
    this.loadNotifications();
  }

  trackByNotificationId(_: number, item: NotificationDto): number {
    return item.notificationId;
  }

  loadNotifications(): void {
    this.loading = true;
    this.notificationsService.getVisibleNotifications().subscribe({
      next: (res: any) => {
        this.notifications = res?.data ?? [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  openDetail(item: NotificationDto, event?: Event): void {
    event?.stopPropagation();
    this.selectedNotification = item;
    this.detailVisible = true;
  }

  closeDetail(): void {
    this.detailVisible = false;
    this.selectedNotification = null;
  }
}
